var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4773",
    "data-name": "Group 4773",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.3,
    height: 14.3,
    viewBox: "0 0 14.3 14.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M0,0H14.3V14.3H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M12.886,11.852v1.77H11.7v-1.77H10.508v-1.77h3.566v1.77Zm-9.508,0v1.77H2.189v-1.77H1v-1.77H4.566v1.77ZM6.943,4.77V3H8.131V4.77H9.32v1.77H5.754V4.77Zm0,2.951H8.131v5.9H6.943ZM2.189,8.9V3H3.377V8.9Zm9.508,0V3h1.189V8.9Z",
    transform: "translate(-0.387 -1.161)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrows);
export default __webpack_public_path__ + "static/media/filter-arrows.4df45c4fac6ea7e4a0e3c23462155437.svg";
export { ForwardRef as ReactComponent };